export default "assets/images/5ba349e3596aca094c41c56966b45dc7.png";